import { IGroupedMention, MENTION_STATUS } from '../../../../../../types/dashboard.types';
import { MentionAccordionCard } from './MentionAccordionCard/MentionAccordionCard';
import { MENTIONS_COLUMNS_CONTENT } from './utils/mentionsColumn.utils';
import { getTotalMentions } from 'utils/getTotalMentions';

import './MentionsColumn.scss';

interface IMentionsColumnProps {
  status: MENTION_STATUS;
  groupedMentions: IGroupedMention[];
  isLoading: boolean;
  onReloadData: () => Promise<void>;
}

export const MentionsColumn = ({ status, groupedMentions = [], isLoading, onReloadData }: IMentionsColumnProps) => {
  const { columnTitle, noMentions } = MENTIONS_COLUMNS_CONTENT[status];
  const totalMentions = getTotalMentions(groupedMentions);

  const renderContent = () => {
    if (isLoading) {
      return (
        <>
          <div className="columnHeader animationLoader"></div>

          {[...Array(3)].map((_, index) => (
            <div className="mentionCard animationLoader" key={index} />
          ))}
        </>
      );
    }

    return (
      <>
        <div className="columnHeader">
          <p className="title">
            {columnTitle} ({totalMentions})
          </p>
        </div>

        <div className="columnContent">
          {totalMentions === 0 ? (
            <div className="noMentions">
              <div className="iconNoMentions">{noMentions.icon}</div>
              <div className="textNoMentions">{noMentions.message}</div>
            </div>
          ) : (
            groupedMentions.map((groupedMention) => (
              <MentionAccordionCard
                key={`${groupedMention.sourceId}-${status}`}
                groupedMention={groupedMention}
                status={status}
                reloadData={onReloadData}
              />
            ))
          )}
        </div>
      </>
    );
  };

  return <div className="mentionsColumnContainer">{renderContent()}</div>;
};
